import React from 'react';
import TouchBackend from 'react-dnd-touch-backend';
import { DndProvider } from 'react-dnd';

const options = {
  enableMouseEvents: true,
  enableTouchEvents: true,
  enableKeyboardEvents: true,
  delayTouchStart: 100,
  ignoreContextMenu: true,
};

export const DnDContext = (Component) => {
  const WrappedComponent = (props) => (
    <DndProvider backend={TouchBackend} options={options}>
      <Component {...props} />
    </DndProvider>
  );

  WrappedComponent.displayName = `DnDContext(${
    Component.displayName || Component.name || 'Component'
  })`;

  return WrappedComponent;
};

export { DragSource, DropTarget, DragLayer } from 'react-dnd';
